// extracted by mini-css-extract-plugin
export default {"button":"t4o8yl","icon":"opxKQF","wrapper":"lnfRGj","label":"PRDfW5"};